const Settings = {
  databaseName: 'getfloorplan-checkout',
  storeName: 'drafts',
  draftKey: 'current-order',
  version: 1,
  lifetime: 7 * 24 * 60 * 60 * 1000,
};

const openDatabase = () => new Promise((resolve, reject) => {
  const request = window.indexedDB.open(Settings.databaseName, Settings.version);
  request.onupgradeneeded = () => {
    const database = request.result;
    if (!database.objectStoreNames.contains(Settings.storeName)) database.createObjectStore(Settings.storeName);
  };
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error);
});

const runTransaction = async (mode, callback) => {
  const database = await openDatabase();
  return new Promise((resolve, reject) => {
    const transaction = database.transaction(Settings.storeName, mode);
    const request = callback(transaction.objectStore(Settings.storeName));
    request.onerror = () => reject(request.error);
    transaction.oncomplete = () => {
      database.close();
      resolve(request.result);
    };
    transaction.onabort = () => {
      database.close();
      reject(transaction.error);
    };
    transaction.onerror = () => reject(transaction.error);
  });
};

export const orderDraftStorage = {
  async get() {
    const draft = await runTransaction('readonly', (store) => store.get(Settings.draftKey));
    if (!draft) return null;
    if (Date.now() - draft.savedAt <= Settings.lifetime) return draft;
    await this.clear();
    return null;
  },

  set(draft) {
    return runTransaction('readwrite', (store) => store.put({ ...draft, savedAt: Date.now() }, Settings.draftKey));
  },

  clear() {
    return runTransaction('readwrite', (store) => store.delete(Settings.draftKey));
  },
};
